import React, { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';
import { ModuleId } from '../../types';
import { GroupId } from '../../config/systemConfig';
import { useFocusTrap } from '../../hooks/useFocusTrap';
interface ValidationErrorModalProps {
  error: {
    moduleId: ModuleId;
    message: string;
    hasContent: boolean;
  };
  selectedGroup: GroupId;
  onClose: () => void;
  onSwitchToGroup6: () => void;
  onNavigateToModules: () => void;
}
export function ValidationErrorModal({
  error,
  selectedGroup,
  onClose,
  onSwitchToGroup6,
  onNavigateToModules
}: ValidationErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  // Escape key to close
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-4956" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-4957">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="validation-error-title" className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8" data-id="element-4958">
          <div className="text-center" data-id="element-4959">
            <div className="text-6xl mb-4" data-id="element-4960">📚</div>
            <h2 id="validation-error-title" className="text-2xl font-bold text-slate-900 mb-3" data-id="element-4961">
              Nog geen vragen beschikbaar
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-4962">
              Voor <strong data-id="element-4963">{error.moduleId}</strong> zijn er nog geen vragen
              beschikbaar voor groep {selectedGroup}.
            </p>

            <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-4 mb-6 text-left" data-id="element-4964">
              <div className="flex items-start gap-3" data-id="element-4965">
                <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-4966" />
                <div className="text-sm text-amber-800" data-id="element-4967">
                  <p className="font-semibold mb-2" data-id="element-4968">Wat kun je doen?</p>
                  <ul className="space-y-1 list-disc list-inside" data-id="element-4969">
                    <li data-id="element-4970">Probeer een ander vak</li>
                    {selectedGroup !== 6 && <li data-id="element-4971">Wissel naar groep 6 in de instellingen</li>}
                    <li data-id="element-4972">Kom later terug voor nieuwe vragen</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex gap-3" data-id="element-4973">
              {selectedGroup !== 6 && <Button onClick={onSwitchToGroup6} variant="secondary" size="lg" fullWidth data-id="element-4974">
                  Wissel naar Groep 6
                </Button>}
              <Button onClick={onNavigateToModules} variant="primary" size="lg" fullWidth data-id="element-4975">
                Bekijk andere vakken
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}